var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.settings.PMHistory && _vm.current_user)?_c('div',{staticClass:"notification"},[(_vm.pms.length>0)?_c('div',{staticClass:"indicator",on:{"click":_vm.showNotifications}},[_vm._v(_vm._s(_vm.pms.filter(pm=>pm.isread==0 && pm.from_id!=_vm.current_user.id).length))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }